import React from "react";
import s from "./ProjectEdit.module.scss";
import { Button } from "@material-ui/core";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { updateReduxKey, setAdditionalSections } from "../MainLayout/action";
import { SECTION } from "../../constants/constants";
import DynamicFormHandler from "../common/DynamicFormHandler/DynamicFormHandler";
import * as R from "ramda";

const ProjectEdit = (props) => {
  const getData = (dataType) => {
    switch (dataType) {
      case "awards":
        return props.additionalSections.awards.data;
      case "certificates":
        return props.additionalSections.certificates.data;
      default:
        return props.initialData.projects;
    }
  };
  // let clonedCopy = R.clone(props.initialData.projects);
  let clonedCopy = R.clone(getData(props.useDataFromKey));

  const handleSave = (items) => {
    if (!items || items.length === 0) {
      props.setSnackBarData({
        open: true,
        message: SECTION.EMPTY_DATA,
      });
      return;
    }
    if (props.useDataFromKey) {
      props.setAdditionalSections({
        key: props.useDataFromKey,
        value: items,
      });
    } else {
      props.storeEditedProjectsSkills({
        projects: items,
      });
    }
    props.setPopOverData({
      currentTarget: null,
      content: "",
    });
    props.setSnackBarData({
      open: true,
      message: SECTION.SAVED_SECTION("Section"),
    });
    // props.storeEditedProjectsSkills({
    //   projects: items,
    // });
    // props.setPopOverData({
    //   currentTarget: null,
    //   content: "",
    // });
    // props.setSnackBarData({
    //   open: true,
    //   message: SECTION.SAVED_SECTION("Personal Projects"),
    // });
  };

  return (
    <section className={s.container}>
      <DynamicFormHandler
        heading={`Edit ${props.useDataFromKey || "Projects"}`}
        expansionPanelList={clonedCopy}
        handleSave={handleSave}
        addToolTip={`Add ${props.useDataFromKey || "Projects"}`}
        getChildChangedData={(list, nestedKey) => {
          clonedCopy = list;
        }}
      />
      <div className={s.actionContainer}>
        <Button
          onClick={() => {
            handleSave(clonedCopy);
          }}
          variant="contained"
          size="small"
          color="primary"
        >
          Save Details
        </Button>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => ({
  ...state.mainLayoutReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    storeEditedProjectsSkills: (projectsObj) => {
      updateReduxKey(projectsObj)(dispatch);
    },
    setAdditionalSections: (additionalSection) => {
      setAdditionalSections(additionalSection)(dispatch);
    },
    dispatch,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProjectEdit)
);
